import type { PaletteMode } from '@mui/material'

export const SAVE_THEME_DATA = 'SAVE_THEME_DATA'

export interface ThemeData {
  mode: PaletteMode
  primary: string
  primaryLight: string
  primaryDark?: string
  primaryLightDark?: string
  selectionDark?: string // dark mode selection/highlight background
  secondary: string
  secondaryLight?: string
  secondaryDark?: string
  error: string
  errorLight?: string
  errorDark?: string
  background?: {
    default?: string
    paper?: string
  }
  btnLight?: string
  btnDark?: string
  btnMain?: string
}

export type ThemeEvent = {
  type: typeof SAVE_THEME_DATA
  data: ThemeData
}

export const initialThemeState: ThemeData = {
  mode: 'light',
  primary: '#28328c', // light mode primary color
  primaryDark: '#7C9FE6', // dark mode primary — soft blue, high contrast on dark bg
  primaryLight: '#008eff', // light mode primary light color
  primaryLightDark: '#56CCF2', // dark mode accent/text-button — bright cyan-blue
  selectionDark: '#6EACDA', // dark mode selection bg — muted dark navy-blue, low contrast
  secondary: '#000036',
  secondaryLight: '#00006A',
  secondaryDark: '#1A2A6C', // dark mode secondary — deep indigo, visible on dark bg
  error: '#f17b7b',
  errorLight: '#ffaaaa',
  errorDark: '#FF6B6B', // dark mode error — vivid red, strong contrast
  background: {
    default: '#ffffff', // light app background
    paper: '#F6F7F8', // light card/paper background
  },
  btnLight: '#EA7425', // light mode button
  btnDark: '#F4A034', // dark mode button — warm amber, great contrast on dark bg
  btnMain: '#EA7425', // Default to light button color
}

export default (
  state: ThemeData = initialThemeState,
  event: ThemeEvent
): ThemeData => {
  switch (event.type) {
    case SAVE_THEME_DATA:
      return {
        ...event.data,
      }
    default:
      return state
  }
}
